export class ServiceValidator {
    static validate(serviceData: any, t: any): string[] {
        const validationErrors: string[] = [];

        if (!serviceData.label?.trim()) {
            validationErrors.push(t("common:name"));
        }

        if (!serviceData.type?.trim()) {
            validationErrors.push(t("common:type"));
        }

        return validationErrors;
    }
}
